import "@hotwired/turbo-rails"
import "@rails/request.js"
import "./controllers"
import * as bootstrap from "bootstrap"
import cookieconsent from "cookieconsent";